// @core/api/endpoints/form/register_form_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormTypeDefinitionResponse,
  RegisterFormTypeRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Register form type
 * Registers a new form type. Products call this on startup to declare their entity types that need forms (event.registration, booking.feedback, hr.application, etc.). FormService then manages form lifecycle for any entity with form aspect of this type.
 */
export async function RegisterFormType(
  data: RegisterFormTypeRequest,
  options?: RequestOptions
): Promise<FormTypeDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/form-types`;
  const requestOptions = options;
  return client.post<FormTypeDefinitionResponse>(requestPath, data, requestOptions);
}
